"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

declare global {
  interface Window {
    smartech?: (...args: unknown[]) => void;
  }
}

export default function NetcorePageBrowse() {
  const pathname = usePathname();

  useEffect(() => {
    const fire = () => {
      if (window.smartech) {
        window.smartech("dispatch", "page browse", {
          page_url: window.location.href || "",
        });
      }
    };

    if (window.smartech) fire();
    else setTimeout(fire, 5000);
  }, [pathname]);

  return null;
}
